import { Crop, CropType } from '../../../../../constants/CropConstants';

export const isCropHybrid = (crop: Crop): boolean => {
  switch (crop) {
    case CropType.RAPESEED_WINTER:
      return true;

    case CropType.RYE_HYBRID_WINTER:
      return true;

    case CropType.WINTER_BARLEY_HYBRID:
      return true;

    default:
      return false;
  }
};

export const getDefaultUnitsPerSack = (crop: Crop): number | null => {
  switch (crop) {
    case CropType.RYE_HYBRID_WINTER:
      return 12;
    case CropType.WINTER_BARLEY_HYBRID:
      return 10;
    case CropType.RAPESEED_WINTER:
      return 3;
    default:
      return null;
  }
};
